import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MaskTable from 'components/templates/mask-table';
import Layout from 'components/templates/layout';
import { useIntl } from 'common/config/i18n';
import type { MasksConfig } from 'types';

import {
  MasksActions,
  UserInfoSelectors,
  MasksConfigActions,
  MasksSelectors,
  MasksConfigSelectors,
  ClearStateSliceActions,
} from 'common/config/store';
import { StyledMainTitle, StyledListUtil } from 'common/styling/mixins';

const { StyledListWrapper, StyledListTitleWrapper } = StyledListUtil;

const Masks: React.FC = () => {
  const dispatch = useDispatch();
  const { t } = useIntl();

  const canWriteMasks = useSelector(UserInfoSelectors.hasWriteAccess('Situations'));
  const masksWithEnabledTranslations = useSelector(MasksSelectors.masksWithEnabledTranslationsSelector);
  const masksConfig: MasksConfig = useSelector(MasksConfigSelectors.masksConfigSelector);

  useEffect(() => {
    dispatch(MasksActions.fetchMasks());
    dispatch(ClearStateSliceActions.clearStateSlice({ sliceReducer: 'Mask' }));
    dispatch(MasksConfigActions.fetchMasksConfig());
  }, [dispatch]);

  return (
    <div>
      <Layout />
      <StyledListWrapper>
        <StyledListTitleWrapper>
          <StyledMainTitle>{t('MaskPage', 'MASK_REPOSITORY_PAGE_H2')}</StyledMainTitle>
        </StyledListTitleWrapper>
        <MaskTable data={masksWithEnabledTranslations} dataConfig={masksConfig} isAdmin={canWriteMasks} />
      </StyledListWrapper>
    </div>
  );
};

export default Masks;
